import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Home from './Component/Home';
import AboutSection from './Component/AboutSection';
import Contact from './Component/Contact';
import Services from './Component/Services';
import NavSection from './Component/NavSection';
import Footer from './Component/Footer';
import Career from './Component/Career';
import NotFound from './Component/NotFound';
import Team from './Component/Team';
import Platfrom from './Component/Platfrom';

import OfferPopup from './Component/OfferPopup';

import './App.css';
import './Component/OfferButton.css';


function AppContent() {

  // Website open hote hi popup show hoga
  const [showOffer, setShowOffer] = useState(true);

  // Current page check karne ke liye
  const location = useLocation();

  // Sirf Home page par floating button show hoga
  const isHomePage = location.pathname === "/";


  return (
    <div>

      {/* Navbar */}
      <NavSection />


      {/* Routes */}
      <Routes>

        <Route path="/" element={<Home />} />

        <Route path="/about" element={<AboutSection />} />

        <Route path="/contact" element={<Contact />} />

        <Route path="/services" element={<Services />} />

        <Route path="/career" element={<Career />} />

        <Route path="/Team" element={<Team />} />

        <Route path="/Platfrom" element={<Platfrom />} />

        <Route path="*" element={<NotFound />} />

      </Routes>


      {/* Footer */}
      <Footer />


      {/* =====================================
          FLOATING OFFER BUTTON
          ONLY HOME PAGE
      ===================================== */}

      {isHomePage && !showOffer && (
     <button
  className="floating-offer-btn"
  onClick={() => setShowOffer(true)}
>
  <span className="offer-icon">
    %
  </span>

  <span className="offer-text">
    Navratri Offer
  </span>
</button>
      )}


      {/* =====================================
          OFFER POPUP
      ===================================== */}

      {showOffer && (
        <OfferPopup
          onClose={() => setShowOffer(false)}
        />
      )}

    </div>
  );
}


function App() {

  return (
    <Router>

      <AppContent />

    </Router>
  );
}


export default App;